import { useAuthContext } from './useAuthContext';
import { useContext, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Context } from 'stores/pageLoaderContext';

function useScrollAnchor() {
  const prevState = useRef({ pathname: '', hash: '', key: '' });
  const { pathname, hash, key } = useLocation();
  const { loading } = useContext(Context);

  useEffect(() => {
    setTimeout(() => {
      if (loading) return;
      if (hash) {
        const elem = document.querySelector(hash);
        elem?.scrollIntoView();
      }

      Object.assign(prevState.current, { pathname, hash, key });
    }, 0);
  });
}

export default useScrollAnchor;
